import { useMemo } from "react";
import {
	getInAppBrowserInfo,
	openInExternalBrowser,
	type InAppBrowserInfo,
} from "@/lib/auth/inAppBrowser";

export function useInAppBrowser(): InAppBrowserInfo & {
	openInExternalBrowser: typeof openInExternalBrowser;
} {
	const info = useMemo(() => getInAppBrowserInfo(), []);
	return { ...info, openInExternalBrowser };
}
